import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// const admin = {
//   main: () => import('@/components/routed/Admin/Main.vue'),
// }

const _public = {
  main: () => import('@/components/routed/Public/Main.vue'),
  home: () => import('@/components/routed/Public/Home.vue'),
  signUp: () => import('@/components/routed/Public/SignUp.vue'),
  index: () => import('@/components/routed/Public/Index.vue'),
  about: () => import('@/components/routed/Public/About.vue'),
  awaitingApproval: () => import('@/components/routed/Public/AwaitingApproval.vue'),
  // educator: () => import('@/components/routed/Public/Educator.vue')
}

const admin = {
  main: () => import('@/components/routed/Admin/Dashboard.vue')
}

const industry = {
  main: () => import('@/components/routed/Public/Industry/Industry.vue'),
  index: () => import('@/components/routed/Public/Industry/Index.vue'),
  browseEducators: () => import('@/components/routed/Public/Industry/BrowseEducators.vue'),
  viewEducator: () => import('@/components/routed/Public/Industry/ViewEducator.vue'),
  profile: () => import('@/components/routed/Public/Industry/Profile.vue'),
}

const educator = {
  main: () => import('@/components/routed/Public/Educator/Educator.vue'),
  index: () => import('@/components/routed/Public/Educator/Index.vue'),
  browseIndustries: () => import('@/components/routed/Public/Educator/BrowseIndustry.vue'),
  viewIndustry: () => import('@/components/routed/Public/Educator/ViewIndustry.vue'),
  profile: () => import('@/components/routed/Public/Educator/Profile.vue'),
}

const file = {
  main: () => import('@/components/routed/File/Main.vue'),
  dashboard: () => import('@/components/routed/File/Dashboard.vue'),
}

const authorizeEntry = (options) => {
  const main = require('../src/main')
  const auth = main.auth
  if (!auth.currentUser) return options.next({name: 'PublicHome', query: {redirect: options.to.fullPath}})
  options.next()
}


import store from './store' // your vuex store 

const requireAuth = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  alert("You must be authenticated to reach this page")
  next('/')
}

const requireAdmin = (to, from, next) => {
  if (store.getters.isAdmin) {
    next()
    return
  }
  alert("You must be an administrator to reach this page")
  next('/')
}





const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: _public.index,     
    },  
    {
      path: '/awaiting',
      name: 'awaitingApproval',
      component: _public.awaitingApproval
    },    
    {
      path: '/about',
      name: 'about',
      component: _public.about
    },     
    {
      path: '/educator',
      name: 'educator',
      component: educator.main,
      beforeEnter: requireAuth,
      children: [
        {
          path: '/',
          name: 'educator',
          component: educator.index,
          meta: {
            transIndex: 50,
          },
        },      
        {
          path: 'industries',
          name: 'browseIndustries',
          component: educator.browseIndustries,
          meta: {
            transIndex: 50,
          },
        },
        {
          path: 'profile',
          name: 'educatorProfile',
          component: educator.profile,
          meta: {
            transIndex: 50,
          },
        },  
        {
          path: 'viewIndustry/:companyID',
          name: 'viewIndustry',
          component: educator.viewIndustry,
          meta: {
            transIndex: 50,
          },
        }              
      ]      
    },    
    {
      path: '/industry',
      component: industry.main,
      beforeEnter: requireAuth,     
      children: [
        {
          path: '/',
          name: 'industry',
          component: industry.index,
          meta: {
            transIndex: 50,
          },
        },      
        {
          path: 'educators',
          name: 'browseEducators',
          component: industry.browseEducators,
          meta: {
            transIndex: 50,
          },
        },
        {
          path: 'profile',
          name: 'industryProfile',
          component: industry.profile,
          meta: {
            transIndex: 50,
          },
        },  
        {
          path: 'viewEducator/:educatorID',
          name: 'viewEducator',
          component: industry.viewEducator,
          meta: {
            transIndex: 50,
          },
        } 
      ],      
    },       
    {
      path: '/admin',
      component: admin.main,
      beforeEnter: requireAdmin
      // meta: {
      //   requiresAuth: true,
      //   requiresAdmin: true
      // },
    },
  ]
})

router.beforeEach((to, from, next) => {
  document.title = "Industry ConnectED"
  next()
})


// router.beforeEach((to, from, next) => {  
//     if(to.matched.some(record => record.meta.requiresAuth)) {
//       console.log("checking auth!!!")
//       const main = require('../src/main')
//       const auth = main.auth
//       if (!auth.currentUser) {
//           console.log("no auth -- taking you to the beginning")
//           return next({
//             path: '/'
//           })
//       } else {
//           if(to.matched.some(record => record.meta.requiresAdmin)) {
//             console.log("this requires admin.  checking admin")
//             var isAdmin = true
//             if( !isAdmin ) {
//               console.log("you are not admin!")
//               return next({
//                 path: '/'
//               })
//             } else {
//               console.log("hi admin")
//               next()
//             }
//           } else {
//             console.log("hi authenticated user")
//             next()
//           }
//       }
//         // if (localStorage.getItem('jwt') == null) {
//         //     next({
//         //         path: '/login',
//         //         params: { nextUrl: to.fullPath }
//         //     })
//         // } else {
//         //     let user = JSON.parse(localStorage.getItem('user'))
//         //     if(to.matched.some(record => record.meta.is_admin)) {
//         //         if(user.is_admin == 1){
//         //             next()
//         //         }
//         //         else{
//         //             next({ name: 'userboard'})
//         //         }
//         //     }else {
//         //         next()
//         //     }
//         // }
//     } else if(to.matched.some(record => record.meta.guest)) {
//         // if(localStorage.getItem('jwt') == null){
//         //     next()
//         // }
//         // else{
//         //     next({ name: 'userboard'})
//         // }
//     } else {
//         next()
//     }
// })


export default router